import React, { lazy, useEffect, useMemo, useState } from 'react';
// cookies
import { useCookies } from 'react-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { apiCartTokenTrack } from '../../analytics/tracker/events/bugTrack';
import { addBtnTrack } from '../../analytics/tracker/events/menuEvents';
import { recsEventsTrack } from '../../analytics/tracker/events/recommendationsTracker';
// Importing Axios
import { UPDATE_CART_ITEMS } from '../../axios/appiendPoints';
import { axiosInstance } from '../../axios/axios';
import { getCartTokenLS, setCheckCartToken } from '../../functions/getCartToken';
import { isUserLoggedIn } from '../../functions/isUserLoggedIn';
// import '../../css/button.css';
import { safeJsonParse } from '../../functions/safeJsonParse';
// redux
import { getCartBillFunction, setCartInRedux } from '../../redux/cart/cartActions';
import { DELIVERY_TYPE, PICKUP_TYPE, SCHEDULED } from '../../webStorage/keys/sessionKeys';
import { getUserId } from '../../webStorage/localStorage';
import {
  getOrderType,
  getOrderTypeName,
  getOrderTypeSession,
  getTableId,
} from '../../webStorage/manageOrderType';
import AddOnVarient from '../cart/addOnVarient';
import ButtonGroup from '../common/buttons/buttonGroup';
import SuspenseWrapper from '../common/suspenseWrapper';
import { addToCartHttp, getMallCart } from '../FoodCourt/AddToCart/addToCartHttp';
import { findAddonVariation, findCart } from './Functions/findCart';
import { ToastError } from '../../toast';
import { useTranslation } from 'react-i18next';
const ShowNextOpenTimePopUp = lazy(() =>
  import(/* webpackChunkName:"ShowNextOpenTimePopUp" */ '../popUp/showNextOpenTimePopUp')
);
const RepeatOrder = lazy(() => import(/* webpackChunkName:"RepeatOrder"*/ '../popUp/repeatOrder'));
const UpdateCartPopup = lazy(() =>
  import(/* webpackChunkName:"UpdateCartPopup"*/ '../popUp/itemOptions/updateCartPopup')
);

const AddToCart = (props) => {
  const dispatch = useDispatch();
  const [cookies, setCookie] = useCookies();
  let orderType = getOrderType(false);
  const restarantSettingFromRedux = useSelector((state) => state.restSetting?.Setting);
  const userDetailsRedux = useSelector((state) => state.userDetails?.Details?.data);
  const userTokenFromRedux = userDetailsRedux?.token;
  const [cartQuantity, setCartQuantity] = useState(0);
  const [finalQuantity, setFinalQuantity] = useState(0);
  const [btn, setBtn] = useState(false);
  const cartFromRedux = useSelector((state) => state.cart?.cart?.cart_items);
  const { mall } = useParams();
  const FCAction = useMemo(() => mall && lazy(() => import('../../redux/FoodCourt/action')), []);
  const FCCarts = useSelector((state) => state.FCReducer);
  const [addOnPopUp, setAddOnPopUp] = useState(false);
  const [updatedItemAddOn, setupdatedItemAddOn] = useState(0);
  const [updatedItemVarient, setupdateItemVarient] = useState(0);
  const [nextOpenTime, setNextOpenTime] = useState(0);
  const [repeatOption, setRepeatOption] = useState(false);
  const [updateCartPopup, setUpdateCartPopup] = useState(false);
  const { t } = useTranslation();
  const cartOperationsHttp = (itemId, quantity, addonIds, newVariation) => {
    const cartTokenFromLS = getCartTokenLS();
    let restaurant_id = restarantSettingFromRedux.id;
    let tableId = getTableId();
    let token = userTokenFromRedux;
    let params = new URLSearchParams();
    newVariation = newVariation ? JSON.stringify(newVariation) : '';
    if (props.customize) params.append('cart_item_id', props?.item?.cart_item_id);
    params.append('cart_token', cartTokenFromLS);
    apiCartTokenTrack({
      fileName: 'addToCart.js',
      functionName: 'cartOperationsHttp',
      cartToken: cartTokenFromLS || cartTokenFromLS + '',
    });
    params.append('restaurant_id', restaurant_id);
    params.append('order_type', getOrderType(true));
    params.append('item_id', itemId);
    params.append('quantity', quantity);
    params.append('table_id', tableId);
    params.append('token', token);
    params.append('variation_ids', '');
    params.append('addon', JSON.stringify(addonIds));
    params.append('new_variation', newVariation);
    params.append('is_new_variation', 1);
    if (props.item.clickTrackingURL || props.explicitlyTriggerRecs) {
      params.append('page_rec', props.from);
      params.append('is_rec', true);
      params.append('type_rec', props.recsType);
    }
    const sessionSetting = getOrderTypeSession();
    if (
      (orderType == DELIVERY_TYPE || orderType == PICKUP_TYPE) &&
      sessionSetting?.orderTime == SCHEDULED &&
      sessionSetting?.epoch > parseInt(Date.now() / 1000)
    ) {
      params.append('epoch', sessionSetting?.epoch);
    }
    setBtn(true);
    axiosInstance
      .post(UPDATE_CART_ITEMS, params)
      .then((response) => {
        setBtn(false);
        if (response.data.status == 2) return setCheckCartToken('');
        if (response.data.status != 1) return ToastError(response.data.message);
        dispatch(setCartInRedux(1, response.data.data.cart));
        dispatch(
          getCartBillFunction(
            cookies?.user_address?.address,
            cartTokenFromLS,
            restarantSettingFromRedux.id,
            JSON.stringify([cookies?.user_address?.lat, cookies?.user_address?.lng]),
            'easyeat'
          )
        );
        if (props.customize) {
          setUpdateCartPopup(true);
        }
        setTimeout(() => setUpdateCartPopup(false), 2000);
      })
      .catch(console.log);
  };
  // get variation from menu page or from cart
  const itemVariation = props.variations || props.newVariation;
  const getAddonAvailabilityStatus = (itemId) => {
    let isAddonAvailable = false;
    restarantSettingFromRedux?.addons?.map((addOn) => {
      if (addOn?.itemids?.includes(itemId)) {
        isAddonAvailable = true;
        return;
      }
    });
    return isAddonAvailable;
  };
  const isCustomizable =
    props.item?.variations?.length > 0 || getAddonAvailabilityStatus(props.itemId);

  const getRecsTrack = () => {
    const recsTypeIndex = ['repeat_items', 'best_seller', 'complete_your_meal'];
    if (recsTypeIndex.includes(props?.recsType)) {
      return recsEventsTrack(recsTypeIndex.indexOf(props?.recsType) + 1, {
        User_name: userDetailsRedux?.name,
        User_Email_ID: userDetailsRedux?.email,
        Item_name: props.item?.name,
        Order_Type: getOrderTypeName(),
        Item_ID: props.item?.id,
        Restaurant_ID: restarantSettingFromRedux?.id,
        Restaurant_Name: restarantSettingFromRedux?.name,
      });
    }

    if (props?.recsType === 'frequently_bought_with') {
      return recsEventsTrack(4, {
        User_name: userDetailsRedux?.name,
        User_Email_ID: userDetailsRedux?.email,
        Item_name: props.item?.name,
        Order_Type: getOrderTypeName(),
        Item_ID: props.item?.id,
        Restaurant_ID: restarantSettingFromRedux?.id,
        Parent_Item_Name: props?.parentItemName,
        Restaurant_Name: restarantSettingFromRedux?.name,
      });
    }

    return null;
  };

  const updatecartWithAddOn = (itemId, quantity, addOn, varient = []) => {
    closeHandler();
    if (varient?.length) {
      setupdateItemVarient(1);
    }
    setupdatedItemAddOn(1);
    setAddOnPopUp(false);
    document.body.style.overflow = 'auto';
    addItem(props.itemId, 1, quantity, addOn, varient);
  };

  const initAddOnVarient = () => {
    setupdateItemVarient(0);
    setupdatedItemAddOn(0);
  };
  useEffect(() => initAddOnVarient(), [updatedItemAddOn, updatedItemVarient]);

  const incrementItemQuantity = (itemId, isVariation = 0, isPopUpOpen = false) => {
    // Only increment the quantity if variation popup is opened, no api calls
    if (isPopUpOpen) return setFinalQuantity((prev) => prev + 1);

    const addOn = getAddonAvailabilityStatus(itemId);
    if (
      !props.variations?.length &&
      (!props.newVariation || props.newVariation == 'null' || !props.newVariation?.length) &&
      !addOn
    )
      return addItem(itemId, isVariation, '1');
    cartQuantity > 0 && setRepeatOption(true);
    setAddOnPopUp(true);
  };

  const decrementItemQuantity = (item, isVariation = 0, isPopUpOpen = false) => {
    // Only decrement the quantity if variation popup is opened and close the popup when user tries to remove the only item
    if (finalQuantity == 1 && isPopUpOpen) {
      setFinalQuantity(0);
      return closeHandler();
    }
    if (isPopUpOpen) return setFinalQuantity((prev) => prev - 1);

    let itemId = item.id || item.item_id;
    const selectedCart = mall ? findCart(FCCarts?.restaurants, props.restaurantId) : cartFromRedux;
    const { addOnToRemove, variationTORemove } = findAddonVariation(selectedCart, item);
    addItem(itemId, isVariation, '-1', addOnToRemove, variationTORemove);
  };

  const addItem = (itemId, isVariation = 0, quantity, addon = '', variation = null) => {
    if (+quantity / Math.abs(+quantity) === 1) {
      addBtnTrack({
        User_Login_state: isUserLoggedIn(),
        User_ID: getUserId(),
        Item_name: props.item?.name,
        Order_Type: getOrderTypeName(),
        Item_ID: props.item?.id,
        Item_Customisable: isCustomizable,
        Restaurant_ID: restarantSettingFromRedux?.id,
        Restaurant_Name: restarantSettingFromRedux?.name,
      });
      getRecsTrack();
    }
    if (!mall) {
      return cartOperationsHttp(itemId, quantity, addon, variation);
    } else {
      const data = {
        addon: addon,
        mall,
        item_id: props.itemId,
        quantity,
        new_variation: variation || [],
        restaurant_id: props.cartpage && mall ? props.restaurantId : restarantSettingFromRedux.id,
        is_new_variation: isVariation,
        token: cookies.fcCartToken,
        table_id: getTableId(),
        setCookie,
        user_id: userDetailsRedux?.user_id,
      };
      if (props.customize) data.cart_item_id = props?.item?.cart_item_id;
      setBtn(true);
      addToCartHttp(data).then((response) => {
        setBtn(false);
        if (response?.status != 1) return;
        if (props.customize) {
          setUpdateCartPopup(true);
        }
        setTimeout(() => setUpdateCartPopup(false), 2000);
        getMallCart({
          mall,
          dispatch,
          FCAction,
          token: response.token,
          table_id: getTableId(),
          user_id: userDetailsRedux?.user_id,
        });
      });
    }
  };
  useEffect(() => {
    if (props.cartpage) return;
    const FCCartList =
      mall &&
      FCCarts?.restaurants?.find(
        (item) => item.restaurant_id == (restarantSettingFromRedux.id || props.restaurantId)
      );
    const cartItem = mall ? FCCartList?.cart_items : cartFromRedux;
    const totalItemCount =
      Array.isArray(cartItem) &&
      cartItem.reduce(
        (total, elem) => (elem.item_id == props.itemId ? total + elem.quantity : total),
        0
      );
    if (totalItemCount >= 0) setCartQuantity(totalItemCount);
  }, [FCCarts, cartFromRedux, props.itemId]);
  useEffect(() => props.quantity && setCartQuantity(props?.quantity), [props.quantity]);

  const closeHandler = () => {
    setRepeatOption(false);
    setAddOnPopUp(false);
    if (props.setCustomize) props.setCustomize(false);
    if (props.setOpenItemOptions) props.setOpenItemOptions(false);
  };

  const isImageClicked =
    props?.openItemOptions && (getAddonAvailabilityStatus(props.itemId) || itemVariation.length);

  return (
    <>
      {props.cartpage ||
      (props.availability && (props.itemStatus == 1 || props.itemStatus == 6)) ? (
        <ButtonGroup
          isHome={props.isHome}
          from={props.from}
          quantity={cartQuantity}
          itemId={props.itemId}
          initiateRcsTrack={!isCustomizable}
          disableBtn={btn}
          incrementFunction={() => incrementItemQuantity(props.itemId, 1)}
          decrementFunction={() => decrementItemQuantity(props.item, 0)}
          serviceable={restarantSettingFromRedux?.serviceable}
          showNextOpenTiming={setNextOpenTime}
          clickTrackingURL={props.item.clickTrackingURL}
        />
      ) : !props.availability ? (
        <div className={`item-out-of-stock ${props?.item?.clickTrackingURL ? 'fs-10' : 'fs-16'} `}>
          {t('out_of_stock')}
        </div>
      ) : null}
      {(props.customize || isImageClicked || (addOnPopUp && !repeatOption)) && (
        <AddOnVarient
          item={props.item}
          close={closeHandler}
          updateCart={updatecartWithAddOn}
          allPrices={props.allPrices}
          addOnId={props.addOnId}
          addOnsObj={props.addOns}
          customize={props.customize}
          variations={safeJsonParse(itemVariation)}
          isAddonAvailable={getAddonAvailabilityStatus(props.itemId)}
          finalQuantity={finalQuantity}
          incrementFunction={() => incrementItemQuantity(props.itemId, 1, true)}
          decrementFunction={() => {
            decrementItemQuantity(props.item, 0, true);
          }}
          setFinalQuantity={setFinalQuantity}
        />
      )}
      {nextOpenTime ? (
        <SuspenseWrapper>
          <ShowNextOpenTimePopUp
            serviceable={restarantSettingFromRedux?.serviceable}
            close={() => setNextOpenTime(0)}
          />
        </SuspenseWrapper>
      ) : null}

      {repeatOption && (
        <SuspenseWrapper>
          <RepeatOrder
            imageUrl={props.imageUrl}
            itemName={props.itemName}
            addOns={props.addOns}
            addonWithQty={props.addon}
            allPrices={props.allPrices}
            itemId={props.itemId}
            cart={mall ? FCCarts?.restaurants : cartFromRedux}
            updateCart={updatecartWithAddOn}
            addonsId={props.addOnId}
            newVariation={props.newVariation}
            restaurantId={props.restaurantId}
            close={closeHandler}
            showAddOnVariation={() => setRepeatOption(false)}
          />
        </SuspenseWrapper>
      )}

      {updateCartPopup && (
        <SuspenseWrapper>
          <UpdateCartPopup close={() => setUpdateCartPopup(false)} />
        </SuspenseWrapper>
      )}
    </>
  );
};

export default AddToCart;
